import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { BillableRateBillableConceptCreateRequest, BillableRateBillableConceptPatchInBatchRequest, BillableRateBillableConceptResponse } from '@/modules/configurationModule/detail/local-accounting/billable/rates/services/billable-rate-billable-concept/billable-rate-billable-concept.dto'

class BillableRateBillableConceptService {
    async create(laboratoryId: number, request: BillableRateBillableConceptCreateRequest): Promise<BillableRateBillableConceptResponse> {
        const response =
            await axios.post<BillableRateBillableConceptResponse>(
                `/configuration/laboratories/${laboratoryId}/billableRateBillableConcepts`,
                request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<BillableRateBillableConceptResponse>> {
        const response =
            await axios.put<IResponseAgGrid<BillableRateBillableConceptResponse>>(
                `/configuration/laboratories/${laboratoryId}/billableRateBillableConcepts`,
                { ...filterModel },
                { params })
        return response.data
    }

    async get(laboratoryId: number, billableRateBillableConceptId : number): Promise<BillableRateBillableConceptResponse> {
        const response =
            await axios.get<BillableRateBillableConceptResponse>(
                `/configuration/laboratories/${laboratoryId}/billableRateBillableConcepts/${billableRateBillableConceptId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response =
            await axios.delete<EntityIdentifierWithErrorResponse[]>(
                `/configuration/laboratories/${laboratoryId}/billableRateBillableConcepts/batch`, { data: request })
        return response.data
    }

    async patch(laboratoryId: number, request: BillableRateBillableConceptPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response =
            await axios.patch<EntityIdentifierWithErrorResponse[]>(
                `/configuration/laboratories/${laboratoryId}/billableRateBillableConcepts/batch`,
                request)
        return response.data
    }
}
export const billableRateBillableConceptService = new BillableRateBillableConceptService()
